import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=1922bddc&scoped=true"
import script from "./ShoppingCart.vue?vue&type=script&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCart.vue?vue&type=style&index=0&id=1922bddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1922bddc",
  null
  
)

export default component.exports